<template>
  <b-nav-item
    v-if="isPermitted('seeHotAlert')"
    right
    :title="count"
    @click="navToHotAlert"
  >
    <feather-icon
      :badge="badge"
      badge-classes="bg-danger"
      class="text-body"
      icon="BellIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'
import { getUserData, isPermitted } from '@/auth/utils'

export default {
  components: {
    BNavItem,
  },
  data() {
    return {
      badge: null,
      count: null,
    }
  },
  created() {
    this.userData = getUserData()
  },
  mounted() {
    this.$root.$on('hotalert_count', count => {
      this.count = count
      this.badge = count > 100 ? '!' : count
    })
  },
  beforeDestroy() {
    this.$root.$off('hotalert_count')
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    navToHotAlert() {
      if (this.$route.path !== '/hotalert') this.$router.push({ name: 'hotalert' })
    },
  },
}
</script>

<style>

</style>
